import { Component, Vue } from "vue-property-decorator";
import { Mutation } from "vuex-class";
import { SET_APP_BACKGROUND_COLOR, SET_TOP_BAR_TEXT, SET_TOP_BAR_VISIBILITY } from "../store/action-types";

@Component
export default class BaseView extends Vue {
  @Mutation(`app/${SET_APP_BACKGROUND_COLOR}`) setAppBackgroundColor: (color: string) => void;

  @Mutation(`app/${SET_TOP_BAR_TEXT}`) setTopBarText: (topBarText: string) => void;

  @Mutation(`app/${SET_TOP_BAR_VISIBILITY}`) setTopBarVisibility: (visibility: string) => void;

  protected topBarText: string;

  created() {
    this.setAppBackgroundColor("default");
    this.setTopBarText(this.topBarText);
  }
}
